// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
	margin: 0;
	font-family: sans-serif;
	color: #344;
}

h5 {
	margin-bottom: 0;
}

p {
	margin-top: 10px;
	letter-spacing: 0.6px;
}

a {
	text-decoration: none;
}

::-webkit-scrollbar {
	width: 10px;
}

::-webkit-scrollbar-track {
	background-color: rgba(0, 0, 0, 0.8);
}

::-webkit-scrollbar-thumb {
	background-color: #4f4f4f;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;;CAEC,SAAS;CACT,uBAAuB;CACvB,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;AACvB","sourcesContent":["html,\nbody {\n\tmargin: 0;\n\tfont-family: sans-serif;\n\tcolor: #344;\n}\n\nh5 {\n\tmargin-bottom: 0;\n}\n\np {\n\tmargin-top: 10px;\n\tletter-spacing: 0.6px;\n}\n\na {\n\ttext-decoration: none;\n}\n\n::-webkit-scrollbar {\n\twidth: 10px;\n}\n\n::-webkit-scrollbar-track {\n\tbackground-color: rgba(0, 0, 0, 0.8);\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: #4f4f4f;\n}\n\n::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
